import React from "react";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Services from "./components/Services";
import Skills from "./components/Skills";
import Portfolio from "./components/Portfolio";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      {/* Header  */}
      <Navbar />

      <Home />
      <Services />
      <Skills />
      <Portfolio />
      <Contact />

      {/* Footer  */}
      <Footer />
    </>
  );
}

export default App;
